import React from 'react';
import Route from '../../layout/AuthenticatedLayoutRoute';
import studentDashboardUrl from './urls';

const StudentDashboard = React.lazy(() => import(/* webpackChunkName: "StudentDashboard" */ '.'));

const allowedRoles = ['STUDENT', 'SUPERUSER'];

const routes = [
    <Route
        path={studentDashboardUrl}
        exact
        key="student-dashboard-base"
        roles={allowedRoles}
        withConstellation={false}
        withSwoosh
    >
        <StudentDashboard />
    </Route>,
    <Route
        path={`${studentDashboardUrl}/:gradeId`}
        exact
        key="student-dashboard-grade"
        roles={allowedRoles}
        withConstellation={false}
        withSwoosh
    >
        <StudentDashboard />
    </Route>,
    <Route
        path={`${studentDashboardUrl}/:gradeId/:classRosterId`}
        exact
        key="student-dashboard-grade-class"
        roles={allowedRoles}
        withConstellation={false}
        withSwoosh
    >
        <StudentDashboard />
    </Route>,
];

export default routes;
